/**
 * Get a browser MIME type from a file name extension.
 * @param {string} fileName File name
 * @returns {string} MIME type
 */
export default function getMimeTypeFromFileName(fileName = '') {
    const extension = fileName.split('.').pop()?.toLowerCase()

    return {
        pdf: 'application/pdf',
        png: 'image/png',
        jpg: 'image/jpeg',
        jpeg: 'image/jpeg',
        gif: 'image/gif',
        webp: 'image/webp',
        svg: 'image/svg+xml',
        mp4: 'video/mp4',
        webm: 'video/webm',
        mov: 'video/quicktime',
    }[extension ?? ''] ?? 'application/octet-stream'
}
